import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";

const SiteFooter = () => (
  <footer className="modern_footer">
    <div className="shell footer_inner">
      <div className="brand_wordmark">
        STAFFING MART
        <p>Connecting talent with opportunity.</p>
      </div>
      <div className="footer_links">
        <Link to="/services">Services</Link>
        <Link to="/contact">Contact</Link>
        <a href="tel:+919081699700">
          <FontAwesomeIcon icon={faPhone} /> +91 90816 99700
        </a>
        <a href="mailto:hrm.staffingmart@gmail.com">
          <FontAwesomeIcon icon={faEnvelope} /> hrm.staffingmart@gmail.com
        </a>
        <a
          href="https://www.instagram.com/staffingmartofficial/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faInstagram} /> Instagram
        </a>
        <a
          href="https://www.linkedin.com/company/staffing-mart"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
        </a>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
